import Vue from 'vue';
import VueI18n from 'vue-i18n';

import en from './en';
import fr from './fr';

Vue.use(VueI18n);

export default new VueI18n({
  locale: 'fr', // set locale
  messages: {
    en,
    fr,
  }, // set locale messages
  silentTranslationWarn: true,
});



// WEBPACK FOOTER //
// ./src/i18n/index.js